import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import { SubscriptionPlansService } from '../../services/subscription-plans.service';
import * as SubscriptionPlansActions from '../actions/subscription-plans.actions';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
@Injectable({ providedIn: 'root' })
export class SubscriptionPlansEffects {
    private actions$ = inject(Actions);
    private subscriptionPlansService = inject(SubscriptionPlansService);
    private messageService = inject(MessageService);
    private router = inject(Router);

    loadSubscriptionPlans$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SubscriptionPlansActions.loadSubscriptionPlans),
            switchMap(() =>
                this.subscriptionPlansService.getSubscriptionPlans().pipe(
                    map(plans => SubscriptionPlansActions.loadSubscriptionPlansSuccess({ plans })),
                    catchError(error => of(SubscriptionPlansActions.loadSubscriptionPlansFailure({ error })))
                )
            )
        )
    );
    loadSubscriptionPlansSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SubscriptionPlansActions.loadSubscriptionPlansSuccess),
                tap(({ plans }) => {
                })
            ),
        { dispatch: false }
    );
    loadSubscriptionPlansFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SubscriptionPlansActions.loadSubscriptionPlansFailure),
                tap(({ error }) => {

                })
            ),
        { dispatch: false }
    );

    userSubscribeToPlan$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SubscriptionPlansActions.userSubscribeToPlan),
            switchMap(({ planId, userId }) =>
                this.subscriptionPlansService.subscribeToPlan(planId, userId).pipe(
                    map(() => SubscriptionPlansActions.userSubscribeToPlanSuccess({ planId, userId })),
                    catchError(error => {
                        const message =
                            error.error?.error
                                ? error.error.error
                                : 'Une erreur est survenue, essayer plus tard';
                        return of(SubscriptionPlansActions.userSubscribeToPlanFailure({ error: message }))
                    })
                )
            )
        )
    );
    userSubscribeToPlanSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SubscriptionPlansActions.userSubscribeToPlanSuccess),
                tap(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Subscription successful',
                        life: 3000
                    });
                })
            ),
        { dispatch: false }
    );
    userSubscribeToPlanFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SubscriptionPlansActions.userSubscribeToPlanFailure),
                tap(({ error }) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error,
                        life: 3000
                    });

                })
            ),
        { dispatch: false }
    );

    loadUserActiveSubscriptions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SubscriptionPlansActions.loadUserActiveSubscriptions),
            switchMap(({ userId }) =>
                this.subscriptionPlansService.getUserActiveSubscriptions(userId).pipe(
                    map(response => SubscriptionPlansActions.loadUserActiveSubscriptionsSuccess({ 
                        subscriptions: response.active_subscriptions || [] 
                    })),
                    catchError(error => of(SubscriptionPlansActions.loadUserActiveSubscriptionsFailure({ error })))
                )
            )
        )
    );

    loadUserActiveSubscriptionsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SubscriptionPlansActions.loadUserActiveSubscriptionsFailure),
                tap(({ error }) => {
                    console.error('Failed to load user subscriptions:', error);
                })
            ),
        { dispatch: false }
    );

}